import { apiSlice } from '..';
import { Faculty, ProgramFacultyRating } from '../generated';

const facultySlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getFacultyByItemSk: builder.query<Faculty[], number>({
            query: (itemSk: number) => `/faculty?itemSk=${itemSk}`,
            keepUnusedDataFor: Number.MAX_SAFE_INTEGER
        }),
        getFacultyRatingByProgramSk: builder.query<ProgramFacultyRating, { programSk: number, facultySk: number }>({
            query: ({ programSk, facultySk }) => `/programs-faculties-ratings/program/${programSk}/faculties/${facultySk}/ratings`,
        }),
    })
});

export const { useGetFacultyByItemSkQuery, useGetFacultyRatingByProgramSkQuery } = facultySlice;
export default facultySlice;
